import React, { useEffect, useState } from "react";
import { API_programas } from "../../config/apiConfig";
import { FaSliders, FaXmark, FaPlus, FaMinus } from "react-icons/fa6";
import "../../pages/admin/css/Dashboard.css";

const FiltrosExpedientes = ({
  filtros,
  setFiltros,
  ocupacionesDisponibles,
  colectivosDisponibles,
}) => {
  const [mostrarFiltros, setMostrarFiltros] = useState(false); //Estado para mostrar/ocultar filtros
  const [filtrosActivos, setFiltrosActivos] = useState({}); //Estado para plegar/desplegar cada filtro

  // Estados para los rangos de edad mínima y máxima
  const [minAge, setMinAge] = useState(14);
  const [maxAge, setMaxAge] = useState(70);

  // Estado para guardar el listado de programas que vienen de la api
  const [programasDisponibles, setProgramasDisponibles] = useState([]);

  useEffect(() => {
    const fetchProgramas = async () => {
      try {
        const res = await fetch(`${API_programas}`);
        const data = await res.json();
        // Filtrar solo los programas reales, excluir recursos de empleo (EMP) y formación (FORM)
        const programasReales = data.filter(
          (item) =>
            !item.nombre?.startsWith("(EMP)") &&
            !item.nombre?.startsWith("(FORM)")
        );
        setProgramasDisponibles(programasReales);
      } catch (error) {
        console.error("Error al cargar programas:", error);
      }
    };

    fetchProgramas();
  }, []);

  // Función para alternar el estado de cada filtro
  const toggleFiltro = (filtro) => {
    setFiltrosActivos((prev) => ({
      ...prev,
      [filtro]: !prev[filtro],
    }));
  };

  // Función para limpiar todos los filtros (plegarlos).
  const handleLimpiarFiltros = () => {
    setFiltros({});
    setFiltrosActivos({});
  };

  // Controladores para forzar límites coherentes al cambiar la edad
  const handleMinAgeChange = (e) => {
    const value = Number(e.target.value);
    // no pasar el maxAge y no bajar de 14
    if (value < 14) {
      setMinAge(14);
    } else if (value > maxAge) {
      setMinAge(maxAge);
    } else {
      setMinAge(value);
    }
  };

  const handleMaxAgeChange = (e) => {
    const value = Number(e.target.value);
    // no pasar de 70 y no ser menor que minAge
    if (value > 70) {
      setMaxAge(70);
    } else if (value < minAge) {
      setMaxAge(minAge);
    } else {
      setMaxAge(value);
    }
  };

  useEffect(() => {
    setFiltros((prev) => ({
      ...prev,
      minAge,
      maxAge,
    }));
  }, [minAge, maxAge]);

  return (
    <>
      <button
        type="submit"
        className="boton-filtros align-center verde bold"
        onClick={() => setMostrarFiltros(!mostrarFiltros)}
      >
        FILTROS {mostrarFiltros ? <FaXmark /> : <FaSliders />}
      </button>

      {mostrarFiltros && (
        <div className="filtros fixed">
          <div className="header-filtros">
            <h3>Filtros</h3>
            <button
              className="boton-cerrar-filtros"
              onClick={() => setMostrarFiltros(false)}
            >
              <FaXmark />
            </button>
          </div>
          {[
            {
              nombre: "Ordenar por",
              contenido: (
                <div className="radio wrap">
                  <label>
                    <input
                      type="radio"
                      name="orden"
                      value="registro"
                      checked={filtros.orden === "registro"}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          orden: e.target.value,
                        }))
                      }
                    />
                    Fecha de registro
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="orden"
                      value="alfabetico"
                      checked={filtros.orden === "alfabetico"}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          orden: e.target.value,
                        }))
                      }
                    />
                    Orden alfabético
                  </label>
                </div>
              ),
            },
            {
              nombre: "Situación laboral",
              contenido: (
                <div className="checkbox wrap">
                  {["desempleado", "trabajando"].map((estado) => (
                    <div key={estado} className="align-center">
                      <input
                        type="checkbox"
                        id={estado}
                        value={estado}
                        checked={
                          filtros.situacionLaboral?.includes(estado) || false
                        }
                        onChange={(e) => {
                          const selected = filtros.situacionLaboral || [];
                          const value = e.target.value;
                          const updated = e.target.checked
                            ? [...selected, value]
                            : selected.filter((s) => s !== value);

                          setFiltros((prev) => ({
                            ...prev,
                            situacionLaboral: updated,
                          }));
                        }}
                      />
                      <label htmlFor={estado}>
                        {estado.charAt(0).toUpperCase() + estado.slice(1)}
                      </label>
                    </div>
                  ))}
                </div>
              ),
            },
            {
              nombre: "Estado del usuario",
              contenido: (
                <div className="radio wrap">
                  <label>
                    <input
                      type="radio"
                      name="estadoUsuario"
                      value="Activo"
                      checked={filtros.estadoUsuario === "Activo"}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          estadoUsuario: e.target.value,
                        }))
                      }
                    />
                    Activo
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="estadoUsuario"
                      value="Inactivo"
                      checked={filtros.estadoUsuario === "Inactivo"}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          estadoUsuario: e.target.value,
                        }))
                      }
                    />
                    Inactivo
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="estadoUsuario"
                      value="Aceptado"
                      checked={filtros.estadoUsuario === "Aceptado"}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          estadoUsuario: e.target.value,
                        }))
                      }
                    />
                    Aceptado (pero no activado)
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="estadoUsuario"
                      value=""
                      checked={!filtros.estadoUsuario}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          estadoUsuario: e.target.value,
                        }))
                      }
                    />
                    Todos
                  </label>
                </div>
              ),
            },
            {
              nombre: "Colectivos",
              contenido: (
                <div className="checkbox wrap">
                  {colectivosDisponibles.map((colectivo, index) => (
                    <div className="align-center" key={index}>
                      <input
                        type="checkbox"
                        id={`colectivo-${index}`}
                        value={colectivo}
                        checked={
                          filtros.colectivos?.includes(colectivo) || false
                        }
                        onChange={(e) => {
                          const selected = filtros.colectivos || [];
                          const value = e.target.value;
                          const updated = e.target.checked
                            ? [...selected, value]
                            : selected.filter((c) => c !== value);
                          setFiltros((prev) => ({
                            ...prev,
                            colectivos: updated,
                          }));
                        }}
                      />
                      <label htmlFor={`colectivo-${index}`}>{colectivo}</label>
                    </div>
                  ))}
                </div>
              ),
            },
            {
              nombre: "Edad",
              contenido: (
                <div className="filtro-edad column">
                  <div className="barra-edad relative w-100">
                    {/* rango “min” */}
                    <input
                      type="range"
                      min="14"
                      max="70"
                      value={minAge}
                      onChange={handleMinAgeChange}
                      className="range range-min absolute w-100"
                    />
                    {/* rango “max” */}
                    <input
                      type="range"
                      min="14"
                      max="70"
                      value={maxAge}
                      onChange={handleMaxAgeChange}
                      className="range range-max absolute w-100"
                    />
                    {/* Barra verde entre edades */}
                    <div
                      className="barra-verde absolute fondo-verde"
                      style={{
                        left: ((minAge - 14) / (70 - 14)) * 100 + "%",
                        right: 100 - ((maxAge - 14) / (70 - 14)) * 100 + "%",
                      }}
                    />
                  </div>

                  {/* Edades seleccionadas */}
                  <div className="edad-seleccionada between w-100">
                    <span>Mín: {minAge}</span>
                    <span>Máx: {maxAge}</span>
                  </div>
                </div>
              ),
            },
            {
              nombre: "Sectores que demanda",
              contenido: (
                <div className="checkbox wrap">
                  {[
                    {
                      value: "AFD",
                      label: "Actividades Físicas y Deportivas (AFD)",
                    },
                    {
                      value: "ACT",
                      label: "Actividades y Competencias Transversales (ACT)",
                    },
                    { value: "ADG", label: "Administración y Gestión (ADG)" },
                    { value: "AGA", label: "Agraria (AGA)" },
                    { value: "ARG", label: "Artes Gráficas (ARG)" },
                    { value: "ART", label: "Artes y Artesanías (ART)" },
                    { value: "COM", label: "Comercio y Marketing (COM)" },
                    { value: "EOC", label: "Edificación y Obra Civil (EOC)" },
                    { value: "ELE", label: "Electricidad y Electrónica (ELE)" },
                    { value: "ENA", label: "Energía y Agua (ENA)" },
                    { value: "FME", label: "Fabricación Mecánica (FME)" },
                    { value: "HOT", label: "Hostelería y Turismo (HOT)" },
                    { value: "IMP", label: "Imagen Personal (IMP)" },
                    { value: "IMS", label: "Imagen y Sonido (IMS)" },
                    { value: "INA", label: "Industrias Alimentarias (INA)" },
                    { value: "IEX", label: "Industrias Extractivas (IEX)" },
                    {
                      value: "IFC",
                      label: "Informática y Comunicaciones (IFC)",
                    },
                    {
                      value: "IMA",
                      label: "Instalación y Mantenimiento (IMA)",
                    },
                    {
                      value: "IAD",
                      label: "Inteligencia Artificial y Data (IAD)",
                    },
                    { value: "MAM", label: "Madera, Mueble y Corcho (MAM)" },
                    { value: "MAP", label: "Marítimo-Pesquera (MAP)" },
                    { value: "QUI", label: "Química (QUI)" },
                    { value: "SAN", label: "Sanidad (SAN)" },
                    { value: "SEA", label: "Seguridad y Medio Ambiente (SEA)" },
                    {
                      value: "SSC",
                      label: "Servicios Socioculturales y a la Comunidad (SSC)",
                    },
                    { value: "TCP", label: "Textil, Confección y Piel (TCP)" },
                    {
                      value: "TMV",
                      label: "Transporte y Mantenimiento de Vehículos (TMV)",
                    },
                    { value: "VIC", label: "Vidrio y Cerámica (VIC)" },
                  ].map((sector, index) => (
                    <div className="align-center" key={index}>
                      <input
                        type="checkbox"
                        id={`sector-${index}`}
                        value={sector.value}
                        checked={
                          filtros.sectores?.includes(sector.value) || false
                        }
                        onChange={(e) => {
                          const selected = filtros.sectores || [];
                          const value = e.target.value;
                          const updated = e.target.checked
                            ? [...selected, value]
                            : selected.filter((s) => s !== value);
                          setFiltros((prev) => ({
                            ...prev,
                            sectores: updated,
                          }));
                        }}
                      />
                      <label htmlFor={`sector-${index}`}>{sector.label}</label>
                    </div>
                  ))}
                </div>
              ),
            },
            {
              nombre: "Programas inscritos",
              contenido: (
                <div className="checkbox wrap">
                  {programasDisponibles.map((programa) => (
                    <div className="align-center programa" key={programa._id}>
                      <input
                        type="checkbox"
                        id={programa._id}
                        value={programa.nombre}
                        checked={
                          filtros.programas?.includes(programa.nombre) || false
                        }
                        onChange={(e) => {
                          const selected = filtros.programas || [];
                          const value = e.target.value;
                          const updated = e.target.checked
                            ? [...selected, value]
                            : selected.filter((p) => p !== value);

                          setFiltros((prev) => ({
                            ...prev,
                            programas: updated,
                          }));
                        }}
                      />
                      <label htmlFor={programa._id}>{programa.nombre}</label>
                    </div>
                  ))}
                </div>
              ),
            },
            {
              nombre: "Fecha registro",
              contenido: (
                <div className="fecha flex">
                  <div className="column">
                    <label>Desde: </label>
                    <input
                      type="date"
                      value={filtros.fechaInicio || ""}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          fechaInicio: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="column">
                    <label>Hasta: </label>
                    <input
                      type="date"
                      value={filtros.fechaFin || ""}
                      onChange={(e) =>
                        setFiltros((prev) => ({
                          ...prev,
                          fechaFin: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              ),
            },
          ].map((filtro, index) => (
            <div key={index} className="filtro">
              <div
                className="nombre-filtro between mayusculas cursor"
                onClick={() => toggleFiltro(filtro.nombre)}
              >
                <p>{filtro.nombre}</p>
                {filtrosActivos[filtro.nombre] ? <FaMinus /> : <FaPlus />}
              </div>
              {filtrosActivos[filtro.nombre] && (
                <div className="filtro-contenido">{filtro.contenido}</div>
              )}
            </div>
          ))}

          <button
            className="limpiar fondo-blanco"
            onClick={handleLimpiarFiltros}
          >
            {" "}
            Limpiar filtros{" "}
          </button>
        </div>
      )}
    </>
  );
};

export default FiltrosExpedientes;
